module.exports = __webpack_public_path__ + "static/media/mota.27221f32.jfif";